import React from "react";
import Selectbox from "./Selectbox";
import NumberInput from "./NumberInput";

export default class DateInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      month: this.props.month || "",
      day: this.props.day || "",
      year: this.props.year || "",
    };

    this.onChange = this.onChange.bind(this);
  }

  render() {
    return (
      <div className="DateInput">
        <div className="row">
          <div className={this.props.hideDay ? "col-sm-6" : "col-sm-4"}>
            <Selectbox
              placeholder="Month"
              name="month"
              value=""
              options={this.props.months}
              onChange={this.onChange}
            />
          </div>
          {this.props.hideDay ? null : (
            <div className="col-sm-4">
              <NumberInput
                name="day"
                value={this.props.day}
                placeholder="Day"
                onChange={this.onChange}
              />
            </div>
          )}
          <div className={this.props.hideDay ? "col-sm-6" : "col-sm-4"}>
            <NumberInput
              name="year"
              value={this.props.year}
              placeholder="Year"
              onChange={this.onChange}
            />
          </div>
        </div>
      </div>
    );
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value }, () => {
      if (typeof this.props.onChange === "function") {
        this.props.onChange({
          target: {
            name: this.props.name,
            value: {
              month: this.state.month,
              day: this.state.day,
              year: this.state.year,
            },
          },
        });
      }
    });
  }
}
